// extracted by mini-css-extract-plugin
export default {"list":"ProjectListPage_list__3izsg","title":"ProjectListPage_title__ucAiC","nameFilter":"ProjectListPage_nameFilter__xeM4Q","pastDueField":"ProjectListPage_pastDueField__69H2m"};